import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=1f1beafe&scoped=true"
import script from "./recordDetail.vue?vue&type=script&lang=js"
export * from "./recordDetail.vue?vue&type=script&lang=js"
import style0 from "./recordDetail.vue?vue&type=style&index=0&id=1f1beafe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1beafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f1beafe')) {
      api.createRecord('1f1beafe', component.options)
    } else {
      api.reload('1f1beafe', component.options)
    }
    module.hot.accept("./recordDetail.vue?vue&type=template&id=1f1beafe&scoped=true", function () {
      api.rerender('1f1beafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wareHouse/recordDetail.vue"
export default component.exports